function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgInstagram = function SvgInstagram(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 551.034 551.034",
    style: {
      enableBackground: "new 0 0 551.034 551.034"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("g", null, React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 275.517,
    y1: 4.57,
    x2: 275.517,
    y2: 549.72,
    gradientTransform: "matrix(1 0 0 -1 0 554)"
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E09B3D"
    }
  }), React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#C74C4D"
    }
  }), React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#C21975"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7024C4"
    }
  })), React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M386.878,0H164.156C73.64,0,0,73.64,0,164.156v222.722 c0,90.516,73.64,164.156,164.156,164.156h222.722c90.516,0,164.156-73.64,164.156-164.156V164.156 C551.033,73.64,477.393,0,386.878,0z M495.6,386.878c0,60.045-48.677,108.722-108.722,108.722H164.156 c-60.045,0-108.722-48.677-108.722-108.722V164.156c0-60.046,48.677-108.722,108.722-108.722h222.722 c60.045,0,108.722,48.676,108.722,108.722L495.6,386.878L495.6,386.878z"
  }), React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 275.517,
    y1: 4.57,
    x2: 275.517,
    y2: 549.72,
    gradientTransform: "matrix(1 0 0 -1 0 554)"
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E09B3D"
    }
  }), React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#C74C4D"
    }
  }), React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#C21975"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7024C4"
    }
  })), React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M275.517,133C196.933,133,133,196.933,133,275.516s63.933,142.517,142.517,142.517 S418.034,354.1,418.034,275.516S354.101,133,275.517,133z M275.517,362.6c-48.095,0-87.083-38.988-87.083-87.083 s38.989-87.083,87.083-87.083c48.095,0,87.083,38.988,87.083,87.083C362.6,323.611,323.611,362.6,275.517,362.6z"
  }), React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 418.31,
    y1: 4.57,
    x2: 418.31,
    y2: 549.72,
    gradientTransform: "matrix(1 0 0 -1 0 554)"
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E09B3D"
    }
  }), React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#C74C4D"
    }
  }), React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#C21975"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7024C4"
    }
  })), React.createElement("circle", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    cx: 418.31,
    cy: 134.07,
    r: 34.15
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/instagram.b1c58ee1.svg";
export { ForwardRef as ReactComponent };